/**
 * Copyright 2024 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const TimeErrorMessage =
  "The specified time must be in the future at the selected timezone.";
export const TimeBetweenErrorMessage =
  "Period between subsequent executions cannot be less than 3h.";
